import React, { useState, useEffect, useCallback, useRef } from "react";
import { 
  CreateTable,
  SuccessMessage,
  FailMessage,
  ConfirmationModal,
  Loading,
  FormatValueToDecimal,

  DateSelect,
  SalesOrderOpenMultipleSelectByCustomer,
  DetectMimeTypeFromBase64, HandleFileUpload, DownloadFile,
  InvoiceStatusSelectWithAll,
  TaxationCodeSelect,
  CustomerSelect
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import { motion, AnimatePresence } from "framer-motion";
import NoAccess from "../NoAccess";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
// MUI Icons
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';

export const DeliveryOrder = ({active}) => {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1)
    const lowerValue = value.toLowerCase();

    const filtered = filteredData.filter(
      (item) =>
        item.doNumber?.toLowerCase().includes(lowerValue)
    );

    setData(filtered);
  };
//#endregion







//#region Filters
  const [showFilterForm, setShowFilterForm] = useState(false);
  const [statusFilter, setStatusFilter] = useState("All");
  const openFilterForm = () => {
    setShowFilterForm(true);
  }
  const closeFilterForm = () => {
    setShowFilterForm(false);
  }
//#endregion








//#region Variables
  const [selectedData, setSelectedData] = useState(null);

  const [deliveryOrderDetails, setDeliveryOrderDetails] = useState([]);
  const [customer, setCustomer] = useState(null);
  const [doNumber, setDONumber] = useState("xxxxxx");
  const [amount, setAmount] = useState(0);
  const today = new Date().toISOString().split("T")[0];
  const [doDate, setDODate] = useState(today);
  const [status, setStatus] = useState("");
  const [notes, setNotes] = useState("");
  const [uploadedFile, setUploadedFile] = useState("");

  const resetVariables = () => {
    setDeliveryOrderDetails([]);
    setCustomer(null);
    setDONumber("xxxxxx");
    setAmount(0);
    setDODate(today);
    setStatus("");
    setNotes("");
    setUploadedFile("");

    setSelectedData(null);
  }

  const fetchDataById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/DeliveryOrder/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);
//#endregion







// #region Add function
  const [showAddForm, setShowAddForm] = useState(false);
  
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetVariables();
  }

  const addHandleClick = async () => {
    openAddForm()
  }

  const handleAddData = async () => {
    const data = {
      deliveryOrderDetails: deliveryOrderDetails,
      customerId: customer?.customerId,
      doNumber: doNumber, //temporary
      amount: amount,
      doDate: doDate,
      status: "Open",
      notes: notes,
      uploadedFile: uploadedFile?.base64,
      createdDate: new Date(),
      createdBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/DeliveryOrder`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion






// #region Update function
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  
  const openUpdateForm = () => {
    setShowUpdateForm(true);
  }
  const closeUpdateForm = () => {
    setShowUpdateForm(false);
    resetVariables();
  }

  const editHandleClick = async (data) => {
    setLoading(true);

    const _data = await fetchDataById(data);
    setSelectedData(_data);

    setDeliveryOrderDetails(_data?.deliveryOrderDetails ?? []);
    setCustomer(_data?.customer ?? null);
    setDONumber(_data?.doNumber ?? "");
    setAmount(_data?.amount ?? 0);
    setDODate(_data?.doDate ?? null);
    setStatus(_data?.status ?? "");
    setNotes(_data?.notes ?? "");
    setUploadedFile(_data?.uploadedFile
                ? {
                    base64: _data?.uploadedFile,
                    contentType: DetectMimeTypeFromBase64(
                      _data?.uploadedFile
                    ),
                    fileName: `UploadedFile.${DetectMimeTypeFromBase64(
                      _data?.uploadedFile
                    ).split("/")[1]}`
                  }
                : null)

    setLoading(false);
    openUpdateForm();
  }

  const handleUpdateData = async () => {
    const data = {
      deliveryOrderDetails: deliveryOrderDetails,
      customerId: customer?.customerId,
      doNumber: doNumber, //temporary
      amount: amount,
      doDate: doDate,
      status: "Open",
      notes: notes,
      updatedDate: new Date(),
      updatedBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/DeliveryOrder/update/${selectedData?.id}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion







// #region View function
  const [showViewForm, setShowViewForm] = useState(false);
  
  const openViewForm = () => {
    setShowViewForm(true);
  }
  const closeViewForm = () => {
    setShowViewForm(false);
    resetVariables();
  }

  const viewHandleClick = async (data) => {
    setLoading(true);

    const _data = await fetchDataById(data);
    setSelectedData(_data);

    setDeliveryOrderDetails(_data?.deliveryOrderDetails ?? []);
    setCustomer(_data?.customer ?? null);
    setDONumber(_data?.doNumber ?? "");
    setAmount(_data?.amount ?? 0);
    setDODate(_data?.doDate ?? null);
    setStatus(_data?.status ?? "");
    setNotes(_data?.notes ?? "");
    setUploadedFile(_data?.uploadedFile
                ? {
                    base64: _data?.uploadedFile,
                    contentType: DetectMimeTypeFromBase64(
                      _data?.uploadedFile
                    ),
                    fileName: `UploadedFile.${DetectMimeTypeFromBase64(
                      _data?.uploadedFile
                    ).split("/")[1]}`
                  }
                : null)

    setLoading(false);
    openViewForm();
  }
//#endregion










// #region View Items
  const [selectedSalesOrder, setSelectedSalesOrder] = useState(null);
  const [showViewSalesOrderDetailForm, setShowViewSalesOrderDetailForm] = useState(false);
  
  const openViewSalesOrderDetailForm = () => {
    setShowViewSalesOrderDetailForm(true);
  }
  const closeViewSalesOrderDetailForm = () => {
    setShowViewSalesOrderDetailForm(false);
    setSelectedSalesOrder(null);
  }

  const viewSalesOrderDetailHandleClick = async (data) => {
    setLoading(true);

    const _data = await fetchDataById(data)
    setSelectedSalesOrder(_data ?? null);

    setLoading(false)
    openViewSalesOrderDetailForm();
  }
// #endregion









//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    'DO NUMBER', 
    // 'DO DATE', 
    'SO NUMBER', 
    'CUSTOMER', 
    // 'DUE DATE', 
    'ITEM/S', 
    // 'BILL AMOUNT', 
    'STATUS', 
    'ACTIONS',
  ]
  const accessors = [
    'do', 
    // 'doDate', 
    'salesOrderNumber', 
    'customer', 
    // 'dueDate', 
    'deliveryOrderDetailLines', 
    // 'billDetailsAmount', 
    'status', 
    'actions'
  ]

  const actions = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleClick,
      visible: true,
    },
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleClick,
      visible: false,
    },
    
    { 
      name: "View Items", 
      tooltip: "view",
      icon: <ListAltIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewSalesOrderDetailHandleClick,
      visible: false,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/DeliveryOrder/status/${statusFilter ? statusFilter : "All"}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
      setFilteredData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [statusFilter]);

  useEffect(() => {
    if(active){
      fetchData();
    }
  }, [active, fetchData])
//#endregion










//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasPayables) {
    return <NoAccess />;
  }
//#endregion


  return (
    <>
      <div className="py-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          {/* Search and Filters */}
          <div className="flex justify-between items-center gap-2 w-full">
            <div className="w-full">
              <input
                type="text"
                placeholder="Search account..."
                className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
              {/* Add filter dropdowns here if needed */}
            </div>
          </div>
          <div className="flex gap-3 w-full justify-start md:justify-end">
            <button className="bg-white border border-gray-300 text-theme-color hover:bg-gray-100 px-3 py-1 rounded-md flex items-center gap-2 hover:bg-opacity-90 transition"
              onClick={openFilterForm}
            >
              <FilterAltIcon/> Filter
            </button>
            <button onClick={addHandleClick} className="flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
              <AddCircleOutlineIcon fontSize="small" /> New DO
            </button>
          </div>
        </div>

        <CreateTable
          tableName={"Delivery Order"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <AddUpdateModal 
        visible={showAddForm}
        onClose={closeAddForm}
        onSave={handleAddData}
        modalName={"Add DO"}

        data={data}
        deliveryOrderDetails={deliveryOrderDetails} setDeliveryOrderDetails={setDeliveryOrderDetails}
        customer={customer} setCustomer={setCustomer}
        doNumber={doNumber} setDONumber={setDONumber}
        amount={amount} setAmount={setAmount}
        doDate={doDate} setDODate={setDODate}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        status={status} setStatus={setStatus}
        notes={notes} setNotes={setNotes}
        isEditable={true}
      />

      <AddUpdateModal 
        visible={showUpdateForm}
        onClose={closeUpdateForm}
        onSave={handleUpdateData}
        modalName={"Update DO"}

        data={data}
        deliveryOrderDetails={deliveryOrderDetails} setDeliveryOrderDetails={setDeliveryOrderDetails}
        customer={customer} setCustomer={setCustomer}
        doNumber={doNumber} setDONumber={setDONumber}
        amount={amount} setAmount={setAmount}
        doDate={doDate} setDODate={setDODate}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        status={status} setStatus={setStatus}
        notes={notes} setNotes={setNotes}
        isEditable={true}
      />

      <ViewModal 
        visible={showViewForm}
        onClose={closeViewForm}
        // onSave={handleViewData}
        modalName={"View DO"}

        data={selectedData}
        deliveryOrderDetails={deliveryOrderDetails} setDeliveryOrderDetails={setDeliveryOrderDetails}
        customer={customer} setCustomer={setCustomer}
        doNumber={doNumber} setDONumber={setDONumber}
        amount={amount} setAmount={setAmount}
        doDate={doDate} setDODate={setDODate}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        status={status} setStatus={setStatus}
        notes={notes} setNotes={setNotes}
        isEditable={false}
      />

      <ViewDetailModal
        visible={showViewSalesOrderDetailForm} 
        onClose={closeViewSalesOrderDetailForm} 
        modalName={"View Items"}
        data={selectedSalesOrder}
      />

      <FilterModal 
        visible={showFilterForm}
        onClose={closeFilterForm}
        modalName={"Filter"}

        statusFilter={statusFilter} setStatusFilter={setStatusFilter}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
}









//#region AddUpdate/View Modal
const AddUpdateModal = ({
  visible, onClose, onSave, modalName,
  
  deliveryOrderDetails, setDeliveryOrderDetails,
  customer, setCustomer,
  doNumber, setDONumber,
  amount, setAmount,
  doDate, setDODate,
  uploadedFile, setUploadedFile,
  status, setStatus,
  notes, setNotes,
  isEditable
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [failMessage, setFailMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDetails, setShowDetails] = useState(true);
  const [deliveryOrderDetailLines, setDeliveryOrderDetailLines] = useState([]);
  const [salesOrders, setSalesOrders] = useState([]);

  const resetLocalVariables = () => {
    setFailMessage("")
    setSalesOrders([])
    setDeliveryOrderDetailLines([])
    setLoading(false);
    setShowDetails(true);
  }

  const fetchSalesOrderDataById = async (_data) => {
    const dataToPost = {
      salesOrderIds: _data.map(i => i.id)
    };

    try {
      const response = await axios.post(`${apiUrl}/api/SalesOrder/do-selection`, dataToPost, {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }

  useEffect(() => {
    if(visible && salesOrders.length > 0){
      const generateDetails = async () => {
        setLoading(true);

        const _salesOrders = await fetchSalesOrderDataById(salesOrders)

        /* const initData = _salesOrders?.salesOrderDetails?.filter(i => i.isReceived !== true)?.map((item) => ({
          itemCode: item.itemCode,
          // orderedQty: item.quantity,
          // receivedQty: item.quantity,
          orderedQty: item.doQuantity,
          receivedQty: item.doQuantity,
          remainingQty: 0,
          unitPrice: item.unitPrice,
          subTotal: item.subTotal,
          taxationCodeId: item?.taxationCodeId,
          taxationCodeDescription: item?.taxationCodeDescription,
          taxationCode: item?.taxationCode,
          totalDiscount: item?.totalDiscount,
          taxAmount: item?.taxAmount,
          totalAmount: item?.totalAmount,
        }))
        setDeliveryOrderDetails(initData) */

        const initData = _salesOrders
          ?.flatMap(so =>
            so.salesOrderDetails
              ?.filter(item => item.isReceived !== true)
              ?.map(item => ({
                salesOrderId: so.id,
                salesOrderNumber: so.soNumber,

                itemCode: item.itemCode,
                itemDescription: item.itemDescription,
                item: item.item,
                uomName: item.uomName,
                brandName: item.brandName,
                categoryName: item.categoryName,
                orderedQty: item.doQuantity,
                receivedQty: item.doQuantity,
                remainingQty: 0,

                unitPrice: item.unitPrice,
                subTotal: item.subTotal,

                taxationCodeId: item.taxationCodeId,
                taxationCodeDescription: item.taxationCodeDescription,
                taxationCode: item.taxationCode,

                totalDiscount: item.totalDiscount,
                taxAmount: item.taxAmount,
                totalAmount: item.totalAmount,
              }))
          ) ?? [];

        setDeliveryOrderDetailLines(initData);
        
        const groupedDetails = [...new Set(initData.map(item => item.salesOrderId))].map(id => ({
          salesOrderId: id,
          deliveryOrderDetailLines: initData.filter(line => line.salesOrderId === id)
        }));

        setDeliveryOrderDetails(groupedDetails);

        setLoading(false);
      }

      generateDetails();
    }
  }, [visible, 
    salesOrders, 
    setDeliveryOrderDetailLines, 
    setDeliveryOrderDetails])

  const [showSalesOrderSelectForm, setShowSalesOrderSelectForm] = useState(false);
  const openSalesOrderSelectForm = () => {
    setShowSalesOrderSelectForm(true);
  }
  const closeSalesOrderSelectForm = () => {
    setShowSalesOrderSelectForm(false);
  }





  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (deliveryOrderDetails.length <= 0 
      || !customer
    ) {
      setFailMessage("Please fill up all required fields.");
      return;
    }
    await onSave();
    closeModal();
  };

  const closeModal = () => {
    setFailMessage("");
    onClose();
    resetLocalVariables();
  };





//#region Customer
  const [showCustomerSelectForm, setShowCustomerSelectForm] = useState(false);
  const openCustomerSelectForm = () => {
    setShowCustomerSelectForm(true);
  }
  const closeCustomerSelectForm = () => {
    setShowCustomerSelectForm(false);
  }
//#endregion







//#region Details
  const [currentPageDetail, setCurrentPageDetail] = useState(1);

  const headersGLAccount = [
    'REFERENCE', 
    'ITEM CODE', 
    'ITEM DESCRIPTION', 
    'ORDERED QTY', 
    'RECEIVED QTY', 
    'REMAINING QTY', 
    // 'UNIT PRICE', 
    // 'SUBTOTAL', 
    // // 'TOTAL TAX', 
    // 'TOTAL DISCOUNT', 
    // 'TOTAL AMOUNT', 
    ...(isEditable ? ['ACTIONS'] : [])
  ]
  const accessorsGLAccount = [
    'salesOrderNumber', 
    'itemCode', 
    'itemDescription', 
    'orderedQty', 
    'receivedQty', 
    'remainingQty', 
    // 'unitPrice', 
    // 'subTotal', 
    // // 'taxAmount', 
    // 'totalDiscount',
    // 'totalAmount',
    ...(isEditable ? ['actions'] : [])
  ]

  const [showAddDetailForm, setShowAddDetailForm] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const openAddDetailForm = () => {
    setShowAddDetailForm(true);
  }
  const closeAddDetailForm = () => {
    setShowAddDetailForm(false);
    setSelectedDetail(null)
  }

  const [showUpdateDetailForm, setShowUpdateDetailForm] = useState(false);
  const openUpdateDetailForm = () => {
    setShowUpdateDetailForm(true);
  }
  const closeUpdateDetailForm = () => {
    setShowUpdateDetailForm(false);
    setSelectedDetail(null)
  }

  const editHandleDetailClick = (_data) => {
    setSelectedDetail(_data)
    openUpdateDetailForm();
  }

  const [showDeleteDetailForm, setShowDeleteDetailForm] = useState(false);
  const openDeleteDetailForm = () => {
    setShowDeleteDetailForm(true);
  }
  const closeDeleteDetailForm = () => {
    setShowDeleteDetailForm(false);
    setSelectedDetail(null)
  }

  const deleteHandleDetailClick = (_data) => {
    setSelectedDetail(_data)
    openDeleteDetailForm();
  }

  const handleDeleteDetail = () => {
    if (!selectedDetail) return;

    // 1. Identify the Sales Order ID of the item being deleted
    const targetSalesOrderId = selectedDetail.salesOrderId;

    // 2. Calculate the new lines first so we can check the remaining count
    const updatedLines = deliveryOrderDetailLines.filter(
      (item) => item.itemCode !== selectedDetail.itemCode
    );

    // 3. Check if there are any items left belonging to that Sales Order
    const hasRemainingItems = updatedLines.some(
      (item) => item.salesOrderId === targetSalesOrderId
    );

    // 4. Update the detailed lines (the list currently shown in the UI)
    setDeliveryOrderDetailLines(updatedLines);

    // 5. If no items are left for this SO, remove the SO from the source state
    if (!hasRemainingItems) {
      setDeliveryOrderDetails((prev) => 
        prev.filter((so) => so.salesOrderId !== targetSalesOrderId)
      );

      setSalesOrders((prev) => 
        prev.filter((so) => so.id !== targetSalesOrderId)
      );
    }
  };

  const actionsDetail = [
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleDetailClick,
      visible: true,
    },
    { 
      name: "Delete", 
      tooltip: "delete",
      icon: <DeleteForeverIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: deleteHandleDetailClick,
      visible: true,
    },
  ];

  const groupedItems = deliveryOrderDetailLines.reduce((acc, item) => {
    const soNumber = item.salesOrderNumber || 'N/A';
    if (!acc[soNumber]) acc[soNumber] = [];
    acc[soNumber].push(item);
    return acc;
  }, {});

  /* useEffect(() => {
    const _totalBillAmount = billDetails?.reduce((acc, item) => acc + (Number(item.salesOrder?.totalAmount) || 0), 0) || 0;
    // setTotalAmount(_totalBillAmount)
    setSubTotal(_totalBillAmount)
  }, [billDetails, setSubTotal]) */
//#endregion 






  const handleFileChange = async (e) => {
    const fileData = await HandleFileUpload(e);

    if (fileData) {
      setUploadedFile(fileData);
    }
  };


  useEffect(() => {
    if(visible){
      const _amount = deliveryOrderDetailLines?.reduce((acc, item) => acc + (Number(item?.totalAmount) || 0), 0) || 0;
      setAmount(_amount)
    }
  }, [deliveryOrderDetailLines, setAmount, visible])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Related Parties */}
                <>
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Related Parties</h3>
                  </div>

                  {isEditable ?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Customer <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Customer"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${customer ? `${customer?.customerId} - ${customer?.name1}` : ""}`}
                          readOnly
                        />
                        {!customer ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCustomerSelectForm}>
                            <PersonSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setCustomer(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                  :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Customer <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Customer"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${customer ? `${customer?.customerId} - ${customer?.name1}` : ""}`}
                          readOnly
                        />
                      </div>
                    </div>
                  }
                </>

                {/* Details */}
                <>
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Delivery Order Details</h3>
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      DO Number
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. DO-2023-001"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={doNumber}
                      onChange={(e) => setDONumber(e.target.value)}
                      readOnly
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      DO Date  <span className="text-red-500">*</span>
                    </label>
                    <DateSelect data={doDate} setData={setDODate} isEditable={isEditable}/>
                  </div>
                </>

                {/* Bills Account */}
                <>
                  <div className="md:col-span-2 mt-4">
                    {/* Toggle Header Button */}
                    <button
                      type="button"
                      onClick={() => setShowDetails(!showDetails)}
                      className="flex items-center justify-between w-full border-b pb-2 group hover:border-theme-color transition-colors"
                    >
                      <div className="flex items-center gap-2">
                        <h3 className={`text-xs font-bold uppercase tracking-wider transition-colors ${showDetails ? 'text-theme-color' : 'text-gray-400'}`}>
                          Sales Order
                        </h3>
                        {/* Badge showing count */}
                        {deliveryOrderDetails?.length > 0 && (
                          <span className="bg-gray-200 text-gray-600 text-[10px] px-2 py-0.5 rounded-full font-bold">
                            {deliveryOrderDetails.length}
                          </span>
                        )}
                      </div>
                      
                      <div className={`transform transition-transform duration-300 text-gray-400 group-hover:text-theme-color ${showDetails ? "rotate-180" : ""}`}>
                        <ExpandMoreIcon /> 
                      </div>
                    </button>

                    {/* Expandable Content Area */}
                    <AnimatePresence>
                      {showDetails && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          className="overflow-hidden"
                        >
                          <div className="py-5 space-y-5">
                            {/* Add button */}
                            <div className="flex gap-3 w-full justify-start">
                              {isEditable &&
                                <>
                                  {customer ? (
                                    <button
                                      type="button"
                                      onClick={openSalesOrderSelectForm}
                                      className="flex items-center gap-2 bg-theme-color text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md active:scale-95"
                                    >
                                      <AddCircleOutlineIcon fontSize="small" />
                                      Add SO
                                    </button>
                                  ) : (
                                    <div className="flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-700 px-4 py-2 rounded-lg text-sm font-medium">
                                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                      </svg>
                                      Please choose a vendor first to add order
                                    </div>
                                  )}
                                </>
                              }
                            </div>

                            {/* Add button */}
                            <div className="hidden gap-3 w-full justify-start">
                              {isEditable &&
                                <>
                                  {customer ? (
                                    <button
                                      type="button"
                                      onClick={openAddDetailForm}
                                      className="flex items-center gap-2 bg-theme-color text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md active:scale-95"
                                    >
                                      <AddCircleOutlineIcon fontSize="small" />
                                      New Item
                                    </button>
                                  ) : (
                                    <div className="flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-700 px-4 py-2 rounded-lg text-sm font-medium">
                                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                      </svg>
                                      Please choose a vendor first to add order
                                    </div>
                                  )}
                                </>
                              }
                            </div>

                            {/* List of Bills Account */}
                            <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hidden">
                              <CreateTable
                                tableName={"Delivery Order Details"}
                                headers={headersGLAccount}
                                accessors={accessorsGLAccount}
                                data={deliveryOrderDetailLines}
                                actions={actionsDetail}
                                currentPage={currentPageDetail}
                                setCurrentPage={setCurrentPageDetail}
                                itemsPerPage={10}
                                totalItems={deliveryOrderDetailLines?.length}
                              />
                            </div>
                            {/* List of Bills Account */}
                            <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                              <div className="space-y-6">
                                {Object.entries(groupedItems).map(([soNumber, items]) => (
                                  <div key={soNumber} className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                                    {/* Header Section */}
                                    <div className="bg-gray-50 px-6 py-4 border-b border-gray-200 flex justify-between items-center">
                                      <div className="flex items-center gap-3">
                                        <span className="bg-blue-100 text-blue-700 text-xs font-bold px-2.5 py-1 rounded-full">
                                          SALES ORDER
                                        </span>
                                        <h3 className="text-lg font-semibold text-gray-800">{soNumber}</h3>
                                      </div>
                                      <span className="text-sm text-gray-500">
                                        {items.length} {items.length === 1 ? 'Item' : 'Items'}
                                      </span>
                                    </div>

                                    {/* Items List */}
                                    <div className="divide-y divide-gray-100">
                                      {items.map((item, index) => (
                                        <div key={index} className="p-6 hover:bg-gray-50 transition-colors">
                                          <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-6 gap-6">
                                            
                                            {/* Item Info */}
                                            <div className="md:col-span-2">
                                              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">Item</p>
                                              <p className="text-sm font-bold text-gray-900">{`${item.itemDescription ?? ""}` }</p>
                                              <p className="text-xs font-bold text-gray-400">{`${item.brandName ?? ""}` }</p>
                                            </div>

                                            {/* Quantities */}
                                            <div>
                                              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">Quantity</p>
                                              <div className="flex items-center gap-2">
                                                <div className="text-sm">
                                                    <span className="text-gray-900 font-semibold">{`${item.receivedQty}`}</span>
                                                    <span className="text-gray-400"> / {`${item.orderedQty}  ${item.uomName ?? ""}`}</span>
                                                </div>
                                              </div>
                                            </div>

                                            {/* Pricing */}
                                            <div>
                                              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">Unit Price</p>
                                              <p className="text-sm text-gray-900">₱{item.unitPrice?.toLocaleString()}</p>
                                            </div>

                                            {/* Totals */}
                                            <div>
                                              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">Total Amount</p>
                                              <p className="text-sm font-bold text-green-600">₱{item.totalAmount?.toLocaleString()}</p>
                                            </div>

                                            {/* Actions */}
                                            {isEditable && (
                                              <div className="flex justify-end items-center gap-2">
                                                {/* Here you map your actionsDetail buttons */}
                                                {actionsDetail?.map((action, actionIdx) => (
                                                    <button
                                                      key={actionIdx}
                                                      onClick={() => action.function(item)}
                                                      className="p-2 text-gray-400 hover:text-red-600 rounded-lg hover:bg-red-50 transition-all"
                                                    >
                                                      {/* Assuming your action has an icon or label */}
                                                      {action.icon || action.label}
                                                    </button>
                                                ))}
                                              </div>
                                            )}
                                          </div>

                                          {/* Sub-details (Discount / Remaining) */}
                                          <div className="mt-4 flex flex-wrap gap-4 pt-4 border-t border-dashed border-gray-100">
                                              <div className="text-xs text-gray-500">
                                                  <span className="font-medium">Remaining:</span> {item.remainingQty}
                                              </div>
                                              <div className="text-xs text-gray-500">
                                                  <span className="font-medium">Discount:</span> ₱{item.totalDiscount}
                                              </div>
                                              <div className="text-xs text-gray-500">
                                                  <span className="font-medium">Subtotal:</span> ₱{item.subTotal}
                                              </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ))}

                                {deliveryOrderDetailLines.length === 0 && (
                                  <div className="text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-200">
                                    <p className="text-gray-500">No delivery order details found.</p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>

                    {/* Summary when collapsed (Optional) */}
                    {!showDetails && deliveryOrderDetailLines?.length > 0 && (
                      <motion.p 
                        initial={{ opacity: 0 }} 
                        animate={{ opacity: 1 }} 
                        className="text-[11px] text-gray-400 mt-2 italic"
                      >
                        Click to view {deliveryOrderDetailLines.length} line items...
                      </motion.p>
                    )}
                  </div>

                  <div className="md:col-span-2">
                    <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col md:flex-row justify-between items-center gap-4">
                      <div className="flex items-center gap-4">
                        <div className="bg-theme-color/10 p-3 rounded-xl">
                          <AccountBalanceWalletIcon className="text-theme-color" />
                        </div>
                        <div>
                          <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                            Total Transaction Amount
                          </p>
                          <p className="text-xs text-gray-500">
                            Sum of all received items above
                          </p>
                        </div>
                      </div>

                      <div className="text-center md:text-right">
                        <div className="flex items-baseline justify-center md:justify-end gap-2">
                          <span className="text-3xl font-black text-gray-800 tracking-tight">
                            {`${getCurrency?.symbol ? getCurrency?.symbol : ""} ${FormatValueToDecimal(amount)}`}
                          </span>
                        </div>
                        {/* Visual indicator of validation */}
                        {amount > 0 ? (
                          <span className="text-[10px] font-bold text-green-500 bg-green-50 px-2 py-0.5 rounded-full uppercase tracking-tighter">
                            ● Ready to Save
                          </span>
                        ) : (
                          <span className="text-[10px] font-bold text-amber-500 bg-amber-50 px-2 py-0.5 rounded-full uppercase tracking-tighter">
                            ○ No amount detected
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </>

                {/* Full Width: Notes */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Notes
                  </label>
                  <textarea
                    rows="3"
                    placeholder="Enter any additional details or remarks..."
                    className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    readOnly={!isEditable}
                  />
                </div>
              </div>
              
              <div className="mt-6 space-y-2">
                <label className="text-[11px] font-bold uppercase tracking-widest text-gray-400 ml-1">Attachment</label>
                
                <div className={`relative group transition-all duration-200 rounded-xl border-2 border-dashed 
                  ${uploadedFile ? 'border-theme-color/30 bg-theme-color/5' : 'border-gray-200 hover:border-theme-color/50 bg-gray-50/50 hover:bg-white'}`}>
                  
                  {/* Hidden Input - clickable over the whole area */}
                  {isEditable && (
                    <input
                      type="file"
                      onChange={handleFileChange}
                      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                    />
                  )}

                  <div className="p-4 flex items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                      {/* Icon based on state */}
                      <div className={`p-2.5 rounded-lg ${uploadedFile ? 'bg-theme-color text-white' : 'bg-gray-200 text-gray-500'}`}>
                        {uploadedFile ? (
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                        ) : (
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                          </svg>
                        )}
                      </div>

                      <div>
                        <p className={`text-sm font-semibold truncate max-w-[200px] ${uploadedFile ? 'text-gray-800' : 'text-gray-500'}`}>
                          {uploadedFile ? uploadedFile.fileName : "Click to upload file"}
                        </p>
                        <p className="text-[11px] text-gray-400 font-medium">
                          {uploadedFile ? (uploadedFile.contentType || "Document") : "Support any file format"}
                        </p>
                      </div>
                    </div>

                    {/* Action Button */}
                    {uploadedFile && (
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); DownloadFile(uploadedFile); }}
                        className="relative z-20 flex items-center gap-2 px-4 py-2 text-xs font-bold text-theme-color bg-white border border-theme-color/20 rounded-lg shadow-sm hover:bg-theme-color hover:text-white transition-all"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                        </svg>
                        DOWNLOAD
                      </button>
                    )}
                  </div>
                </div>
                
                {!uploadedFile && <p className="text-[10px] text-gray-400 italic ml-1">* No file attached yet</p>}
              </div>

            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <AddUpdateDetailModal 
        visible={showAddDetailForm} 
        onClose={closeAddDetailForm}
        modalName={"Add Item"}
        data={selectedDetail}
        deliveryOrderDetails={deliveryOrderDetailLines} setDeliveryOrderDetails={setDeliveryOrderDetailLines}
        isEditable={true}
      />

      <AddUpdateDetailModal 
        visible={showUpdateDetailForm} 
        onClose={closeUpdateDetailForm}
        modalName={"Update Item"}
        data={selectedDetail}
        deliveryOrderDetails={deliveryOrderDetailLines} setDeliveryOrderDetails={setDeliveryOrderDetailLines}
        isEditable={true}
      />

      <CustomerSelect 
        visible={showCustomerSelectForm} 
        onClose={closeCustomerSelectForm}
        modalName={"Select Customer"}
        data={customer} setData={setCustomer}
      />

      <SalesOrderOpenMultipleSelectByCustomer 
        visible={showSalesOrderSelectForm} 
        onClose={closeSalesOrderSelectForm}
        modalName={"Select Available SO"}
        data={salesOrders} setData={setSalesOrders}
        customer={customer}
      />

      <ConfirmationModal 
        visible={showDeleteDetailForm} 
        onClose={closeDeleteDetailForm} 
        onSave={handleDeleteDetail} 
        modalName={"Delete"} 
        message={`Do you want to remove this account [ ${`${selectedDetail?.itemCode} ${selectedDetail?.itemDescription ?? ""}`} ]?.`}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
};
const ViewModal = ({
  visible, onClose, modalName,
  deliveryOrderDetails, // Array of items received
  salesOrder,      // The source SO object
  doNumber,           // DO ID
  amount,             // Total amount
  doDate,             // Date of receipt
  uploadedFile,       // Attachment
  status,             // Receipt status
  notes,              // Remarks
  data,
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const printRef = useRef();
  const [isDownloading, setIsDownloading] = useState(false);

  // Helper for currency formatting
  const formatVal = (num) => {
    return typeof FormatValueToDecimal === "function" 
      ? FormatValueToDecimal(num) 
      : Number(num || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });
  };

  const downloadHandleClick = async () => {
    const element = printRef.current;
    if (!element) return;

    setIsDownloading(true);
    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        windowWidth: 1200,
        windowHeight: element.scrollHeight
      });

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save(`Good_Receipt_${doNumber || 'Export'}.pdf`);
    } catch (error) {
      console.error("PDF Generation Error:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const closeModal = () => {
    onClose();
  };

  if (!visible) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.95, opacity: 0, y: 20 }}
          className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
        >
          {/* Header */}
          <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName || "Delivery Order Preview"}</h2>
              <p className="text-sm text-gray-500">Inventory Receiving Document</p>
            </div>
            <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="p-8 overflow-y-auto custom-scrollbar">
            <div ref={printRef} className="max-w-4xl mx-auto bg-white shadow-xl border border-gray-200 rounded-sm p-12 min-h-[800px] flex flex-col">
              
              {/* DOCUMENT HEADER */}
              <div className="flex justify-between items-start border-b-4 border-theme-color pb-8 mb-10">
                <div>
                  <h1 className="text-4xl font-black text-theme-color tracking-tighter mb-2">DELIVERY ORDER</h1>
                  <div className="flex items-center gap-2">
                    <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase ${status === 'Received' || status === 'Completed' ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'}`}>
                      {status || 'Pending'}
                    </span>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Receipt Number</p>
                  <p className="text-2xl font-mono font-bold text-theme-color">#{doNumber || '---'}</p>
                  <p className="mt-4 text-[10px] font-bold text-gray-400 uppercase tracking-widest">Date Received</p>
                  <p className="text-sm font-bold text-gray-800">{doDate ? new Date(doDate).toLocaleDateString() : 'N/A'}</p>
                </div>
              </div>

              {/* REFERENCE INFO */}
              <div className="grid grid-cols-2 gap-12 mb-12">
                <div className="space-y-3">
                  <h3 className="text-[11px] font-bold text-theme-color uppercase tracking-[0.2em] border-b border-gray-100 pb-2">Customer Details</h3>
                  {data?.customer ? (
                    <div>
                      <p className="font-bold text-gray-900 text-lg">{data.customer.name1 || data.customer.Name1}</p>
                      <p className="text-sm text-gray-500">{data.customer.name2 || ''}</p>
                      <p className="text-xs text-gray-400 mt-1">Customer ID: {data.customer.customerId || 'N/A'}</p>
                    </div>
                  ) : (
                    <p className="text-sm italic text-gray-400">Linked to Sales Order: {salesOrder?.soNumber || 'N/A'}</p>
                  )}
                </div>
                <div className="space-y-4 bg-gray-50 p-6 rounded-xl border border-gray-100">
                  <div className="flex justify-between">
                    <span className="text-[10px] font-bold text-gray-400 uppercase">SO Reference</span>
                    <span className="text-sm font-bold text-gray-700 hidden">#{salesOrder?.soNumber || 'N/A'}</span>
                    <span className="text-sm font-bold text-gray-700">
                      { data?.deliveryOrderDetails.map((item, index) => {
                        return (
                          <p key={index} className="text-sm font-bold text-gray-700">
                            {item.salesOrderNumber ?? "UNKNOWN-SO"}
                          </p>
                        )
                      })

                      }
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-[10px] font-bold text-gray-400 uppercase">Currency</span>
                    <span className="text-sm font-bold text-gray-700">{getCurrency?.code || 'PHP'}</span>
                  </div>
                </div>
              </div>

              {/* ITEMS TABLE */}
              <div className="flex-grow">
                <table className="w-full">
                  <thead>
                    <tr className="bg-theme-color text-white">
                      <th className="py-3 px-4 text-left text-[10px] font-bold uppercase tracking-widest">Item</th>
                      <th className="py-3 px-4 text-center text-[10px] font-bold uppercase tracking-widest">Qty Received</th>
                      <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest">Unit Price</th>
                      <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest">Subtotal</th>
                      <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest">Discount</th>
                      <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest">Total</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100 border-b border-gray-200">
                    {data?.deliveryOrderDetailLines?.length > 0 ? (
                      data?.deliveryOrderDetailLines.map((item, idx) => (
                        <tr key={idx}>
                          <td className="py-5 px-4">
                            <p className="text-sm font-bold text-gray-800">{`${item.itemDescription ?? ""} ${item.brandName ?? ""}`}</p>
                            {item.notes && <p className="text-[10px] text-gray-400 mt-1 italic">{item.notes}</p>}
                          </td>
                          <td className="py-5 px-4 text-center text-sm font-bold text-theme-color">
                            {`${item.receivedQty || item.quantity || 0} ${item.uomName || ""}`}
                          </td>
                          <td className="py-5 px-4 text-right text-sm font-medium text-gray-600">
                            {getCurrency?.symbol} {formatVal(item.unitPrice)}
                          </td>
                          <td className="py-5 px-4 text-right text-sm font-bold text-gray-900">
                            {getCurrency?.symbol} {formatVal((item.subTotal || 0) )}
                          </td>
                          <td className="py-5 px-4 text-right text-sm font-bold text-gray-900">
                            {getCurrency?.symbol} {formatVal((item.totalDiscount || 0))}
                          </td>
                          <td className="py-5 px-4 text-right text-sm font-bold text-gray-900">
                            {getCurrency?.symbol} {formatVal((item.totalAmount || 0))}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="py-10 text-center text-sm text-gray-400 italic">No items found in this receipt</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* FOOTER SECTION */}
              <div className="mt-10 flex justify-between items-start gap-4">
                <div className="w-full">
                  <h4 className="text-[10px] font-black text-gray-900 uppercase tracking-widest mb-2">Remarks</h4>
                  <p className="text-xs text-gray-500 leading-relaxed bg-gray-50 p-4 rounded-lg border border-dashed border-gray-200">
                    {notes || "No special instructions provided."}
                  </p>
                  
                  {/* Attachment Info */}
                  {uploadedFile && (
                    <div className="mt-4 flex items-center gap-2 text-theme-color">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                      </svg>
                      <span className="text-[10px] font-bold uppercase tracking-tight">Attachment: {uploadedFile.name || 'Document.pdf'}</span>
                    </div>
                  )}
                </div>
                
                <div className="w-full">
                  <div className="flex justify-between items-center pt-4 border-t-2 border-theme-color">
                    <span className="text-xs font-black text-gray-900 uppercase">Total Received Value</span>
                    <span className="text-2xl font-black text-theme-color">
                      {getCurrency?.symbol} {formatVal(amount)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
            <button
              onClick={closeModal}
              className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
            >
              Close
            </button>
            <button
              onClick={downloadHandleClick}
              disabled={isDownloading}
              className={`px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm flex items-center gap-2 ${isDownloading ? 'opacity-70 cursor-not-allowed' : 'hover:opacity-90'}`}
            >
              {isDownloading ? (
                <>
                  <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                  Processing...
                </>
              ) : 'Download Receipt'}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};
//#endregion








//#region Detail
const AddUpdateDetailModal = ({
  visible, onClose, onSave, modalName,
  data,
  deliveryOrderDetails, setDeliveryOrderDetails,
  isEditable
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");

  const [failMessage, setFailMessage] = useState("");
  const [item, setItem] = useState(null);
  const [itemCode, setItemCode] = useState("");
  const [itemDescription, setItemDescription] = useState("");
  const [orderedQty, setOrderedQty] = useState(0);
  const [receivedQty, setReceivedQty] = useState(0);
  const [remainingQty, setRemainingQty] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [taxationCode, setTaxationCode] = useState(null);

  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (!itemCode) {
      setFailMessage("Please fill up Item Code fields .");
      return;
    }

    if(modalName === "Add Item"){
      const foundData = deliveryOrderDetails.find(i => i.itemCode === itemCode)

      if (foundData) {
        setFailMessage("Already added this item.");
        return;
      }

      const newData = {
        item: item,
        itemCode: itemCode,
        itemDescription: itemDescription,
        orderedQty: orderedQty,
        receivedQty: receivedQty,
        remainingQty: remainingQty,
        unitPrice: unitPrice,
        subTotal: subTotal,
        taxationCodeId: taxationCode?.id,
        taxationCodeDescription: taxationCode?.description,
        taxationCode: taxationCode,
        totalDiscount: totalDiscount,
        taxAmount: taxAmount,
        totalAmount: totalAmount,
        // salesOrderId: data.salesOrderId,
        // salesOrderNumber: data.salesOrderNumber,
      }

      setDeliveryOrderDetails((prev) => [...prev, newData])
    }

    if(modalName === "Update Item"){
      const foundData = deliveryOrderDetails.find(i => i.itemCode === itemCode && data?.itemCode !== itemCode)

      if (foundData) {
        setFailMessage("Already added this item.");
        return;
      }

      const newData = {
        item: item,
        itemCode: itemCode,
        itemDescription: itemDescription,
        orderedQty: orderedQty,
        receivedQty: parseFloat(receivedQty ?? 0),
        remainingQty: remainingQty,
        unitPrice: unitPrice,
        subTotal: subTotal,
        taxationCodeId: taxationCode?.id,
        taxationCodeDescription: taxationCode?.description,
        taxationCode: taxationCode,
        totalDiscount: totalDiscount,
        taxAmount: taxAmount,
        totalAmount: totalAmount,
        salesOrderId: data?.salesOrderId,
        salesOrderNumber: data?.salesOrderNumber,
      }

      setDeliveryOrderDetails(prev =>
        prev.map(item => {
          return  item.itemCode === data?.itemCode
              ? newData
              : item
          }
        )
      );
    }

    closeModal();
  };

  const resetLocalVariables = () => {
    setItem(null)
    setItemCode("")
    setItemDescription("")
    setOrderedQty(0)
    setReceivedQty(0)
    setRemainingQty(0)
    setUnitPrice(0)
    setSubTotal(0)
    setTotalDiscount(0);
    setTaxAmount(0);
    setTotalAmount(0);
    setTaxationCode(null);
  }

  const closeModal = () => {
    setFailMessage("");
    onClose();
    resetLocalVariables();
  };

  useEffect(() => {
    if(visible){
      setItem(data?.item ?? null)
      setItemCode(data?.itemCode ?? "")
      setItemDescription(data?.itemDescription ?? "")
      setOrderedQty(data?.orderedQty ?? 0)
      setReceivedQty(data?.receivedQty ?? 0)
      setRemainingQty(data?.remainingQty ?? 0)
      setUnitPrice(data?.unitPrice ?? 0)
      setSubTotal(data?.subTotal ?? 0)
      setTotalDiscount(data?.totalDiscount ?? 0);
      setTaxAmount(data?.taxAmount ?? 0);
      setTotalAmount(data?.totalAmount ?? 0);
      setTaxationCode(data?.taxationCode ?? null);
    }
  }, [visible, data])

  const toNumber = (val) => {
    const n = parseFloat(val);
    return isNaN(n) ? 0 : n;
  };

  useEffect(() => {
    const taxedAmount =
      toNumber(subTotal) + toNumber(taxAmount);

    const _totalAmount =
      taxedAmount - toNumber(totalDiscount);

    setTotalAmount(_totalAmount);
  }, [subTotal, taxAmount, totalDiscount]);

  useEffect(() => {
    const _subTotal =
      toNumber(unitPrice) * toNumber(receivedQty);

    setSubTotal(_subTotal);
  }, [unitPrice, receivedQty]);

  useEffect(() => {
    const _remainingQty =
      toNumber(orderedQty) - toNumber(receivedQty);

    setRemainingQty(_remainingQty);
  }, [orderedQty, receivedQty]);

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <>
                  {/* --- Section 1: Entities --- */}
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Basic Details</h3>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Item
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. ITEM0001"
                      className="bg-gray-200 text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={item ? `${item?.itemCode} - ${item?.itemDescription ? `${item?.itemDescription} ${item?.brandName ? `(${item?.brandName})` : ""}` : ""}` : ""}
                      onChange={(e) => setItemCode(e.target.value)}
                      readOnly
                    />
                  </div>

                  <div className="hidden">
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Item Description
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. ITEM0001"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={itemDescription}
                      onChange={(e) => setItemDescription(e.target.value)}
                      readOnly={!isEditable}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Ordered Quantity
                    </label>
                    <input
                      type="number"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={orderedQty}
                      onChange={(e) => setOrderedQty(e.target.value)}
                      readOnly={!isEditable}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Received Quantity
                    </label>
                    <input
                      type="number"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={receivedQty}
                      onChange={(e) => setReceivedQty(e.target.value)}
                      readOnly={!isEditable}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Remaining Quantity
                    </label>
                    <input
                      type="number"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={remainingQty}
                      onChange={(e) => setRemainingQty(e.target.value)}
                      readOnly={!isEditable}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Unit Price
                    </label>
                    <input
                      type="number"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={unitPrice}
                      onChange={(e) => setUnitPrice(e.target.value)}
                      readOnly={!isEditable}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Taxation Code
                    </label>
                    <TaxationCodeSelect data={taxationCode} setData={setTaxationCode} isEditable={isEditable}/>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Tax Amount
                    </label>
                    <input
                      type="number"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={taxAmount}
                      onChange={(e) => setTaxAmount(e.target.value)}
                      readOnly={!isEditable}
                    />
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <span className="font-semibold text-gray-400 italic">
                        {getCurrency?.symbol ?? ""}
                        {FormatValueToDecimal(taxAmount || 0)}
                      </span>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Discount
                    </label>
                    <input
                      type="number"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={totalDiscount}
                      onChange={(e) => setTotalDiscount(e.target.value)}
                      readOnly={!isEditable}
                    />
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <span className="font-semibold text-gray-400 italic">
                        {getCurrency?.symbol ?? ""}
                        {FormatValueToDecimal(totalDiscount || 0)}
                      </span>
                    </div>
                  </div>

                  <div className="md:col-span-2">
                    <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                      
                      {/* Left Side: Details Breakdown */}
                      <div className="flex gap-4 w-full lg:w-auto">
                        <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                          <AccountBalanceWalletIcon className="text-theme-color" />
                        </div>
                        
                        <div className="flex-1 space-y-3">
                          <div>
                            <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                              Transaction Summary
                            </p>
                            <p className="text-xs text-gray-500">Breakdown of all line items</p>
                          </div>

                          {/* Mini Table for Subtotal, Discount, Tax */}
                          <div className="grid grid-cols-1 gap-2 border-t border-gray-50 pt-3">
                            <div className="flex justify-between items-center gap-8">
                              <span className="text-xs font-medium text-gray-500">Subtotal</span>
                              <span className="text-sm font-semibold text-gray-700">
                                {getCurrency?.symbol} {FormatValueToDecimal(subTotal)}
                              </span>
                            </div>
                            
                            <div className="flex justify-between items-center gap-8">
                              <span className="text-xs font-medium text-gray-500">Total Discount</span>
                              <span className="text-sm font-semibold text-red-500">
                                - {getCurrency?.symbol} {FormatValueToDecimal(totalDiscount)}
                              </span>
                            </div>

                            <div className="flex justify-between items-center gap-8">
                              <span className="text-xs font-medium text-gray-500">Tax Amount</span>
                              <span className="text-sm font-semibold text-gray-700">
                                + {getCurrency?.symbol} {FormatValueToDecimal(taxAmount)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right Side: Final Total & Status */}
                      <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                        <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                          Final Total Amount
                        </p>
                        <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                          <span className="text-4xl font-black text-gray-900 tracking-tight">
                            {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalAmount)}`}
                          </span>
                        </div>

                        {/* Visual indicator of validation */}
                        {totalAmount > 0 ? (
                          <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                            <span className="mr-1">●</span> Ready to Save
                          </span>
                        ) : (
                          <span className="inline-flex items-center text-[10px] font-bold text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-amber-100">
                            <span className="mr-1">○</span> No amount detected
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
const ViewDetailModal = ({
  visible, onClose, onSave, modalName,
  data,
}) => {
  
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");

  const closeModal = () => {
    onClose();
  };

  const [selectedItemDetail, setSelectedItemDetail] = useState(null);
  const [showItemDetailForm, setShowItemDetailForm] = useState(false);
  const openItemDetailForm = () => {
    setShowItemDetailForm(true);
  }
  const closeItemDetailForm = () => {
    setShowItemDetailForm(false);
  }

  const viewItemDetailHandleClick = (_data) => {
    setSelectedItemDetail(_data)
    openItemDetailForm()
  }

  const [currentPageSalesOrderDetail, setCurrentPageSalesOrderDetail] = useState(1);

  const headersSalesOrderDetail = [
    'REFERENCE', 
    'ITEM', 
    'SALES (Dr)', 
    'INVENTORY (Cr)', 
    'ORDERED QTY', 
    'RECEIVED QTY', 
    'REMAINING QTY', 
    // 'UNIT PRICE', 
    // 'SUBTOTAL', 
    // // 'TOTAL TAX', 
    // 'TOTAL DISCOUNT', 
    // 'TOTAL AMOUNT', 
    'ACTIONS'
  ]
  const accessorsSalesOrderDetail = [
    'salesOrderNumber', 
    'item', 
    'drAccount', 
    'crAccount', 
    'orderedQty', 
    'receivedQty', 
    'remainingQty', 
    // 'unitPrice', 
    // 'subTotal', 
    // // 'taxAmount', 
    // 'totalDiscount',
    // 'totalAmount',
    'actions'
  ]

  const actionsSalesOrderDetail = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewItemDetailHandleClick,
      visible: true,
    },
  ];

  const [vatableAmount, setVatableAmount] = useState(0)
  const [subTotal, setSubTotal] = useState(0)
  const [tax, setTax] = useState(0)
  const [discount, setDiscount] = useState(0)
  
  useEffect(() => {
    const _subTotal = data?.deliveryOrderDetails?.reduce((acc, item) => acc + (Number(item.salesOrder?.subTotal) || 0), 0)
    const _tax = data?.deliveryOrderDetails?.reduce((acc, item) => acc + (Number(item.salesOrder?.taxAmount) || 0), 0)
    const _discount = data?.deliveryOrderDetails?.reduce((acc, item) => acc + (Number(item.salesOrder?.totalDiscount) || 0), 0)

    const _vatableAmount = _subTotal - _tax;
    setVatableAmount(_vatableAmount)
    setSubTotal(_subTotal)
    setTax(_tax)
    setDiscount(_discount)
  }, [data])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="py-5 space-y-5">
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                  <CreateTable
                    tableName={"Delivery Order Detail"}
                    headers={headersSalesOrderDetail}
                    accessors={accessorsSalesOrderDetail}
                    data={data?.deliveryOrderDetailLines}
                    actions={actionsSalesOrderDetail}
                    currentPage={currentPageSalesOrderDetail}
                    setCurrentPage={setCurrentPageSalesOrderDetail}
                    itemsPerPage={10}
                    totalItems={data?.deliveryOrderDetailLines?.length}
                  />
                </div>

                <div className="md:col-span-2">
                  <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col md:flex-row justify-between items-center gap-4">
                    <div className="flex gap-4 w-full lg:w-auto">
                      <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                        <AccountBalanceWalletIcon className="text-theme-color" />
                      </div>
                      <div className="flex-1 space-y-3">
                        <div>
                          <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                            Total Transaction Amount
                          </p>
                          <p className="text-xs text-gray-500">
                            Sum of all order items above
                          </p>
                        </div>
                        <div className="hidden grid-cols-1 gap-2 border-t border-gray-50 pt-3">
                          <div className="flex justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">Vatable Amt</span>
                            <span className="text-sm font-semibold text-gray-700">
                              {getCurrency?.symbol} {FormatValueToDecimal(vatableAmount)}
                            </span>
                          </div>
                          <div className="flex justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">Tax</span>
                            <span className="text-sm font-semibold text-gray-700">
                              {getCurrency?.symbol} {FormatValueToDecimal(tax)}
                            </span>
                          </div>
                          <div className="flex justify-between items-center gap-8 border-t">
                            <span className="text-xs font-medium text-gray-500">Subtotal</span>
                            <span className="text-sm font-semibold text-gray-700">
                              {getCurrency?.symbol} {FormatValueToDecimal(subTotal)}
                            </span>
                          </div>
                          
                          <div className="flex justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">Total Discount</span>
                            <span className="text-sm font-semibold text-red-500">
                              - {getCurrency?.symbol} {FormatValueToDecimal(discount)}
                            </span>
                          </div>

                          <div className="hidden justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">Tax Amount</span>
                            <span className="text-sm font-semibold text-gray-700">
                              + {getCurrency?.symbol} {FormatValueToDecimal(data?.taxAmount)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="text-center md:text-right">
                      <div className="flex items-baseline justify-center md:justify-end gap-2">
                        <span className="text-3xl font-black text-gray-800 tracking-tight">
                          {`${getCurrency?.symbol ? getCurrency?.symbol : ""} ${FormatValueToDecimal(data?.amount)}`}
                        </span>
                      </div>
                      {/* Visual indicator of validation */}
                      {data?.amount > 0 ? (
                        <span className="text-[10px] font-bold text-green-500 bg-green-50 px-2 py-0.5 rounded-full uppercase tracking-tighter">
                          ● Ready to Save
                        </span>
                      ) : (
                        <span className="text-[10px] font-bold text-amber-500 bg-amber-50 px-2 py-0.5 rounded-full uppercase tracking-tighter">
                          ○ No amount detected
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <AddUpdateDetailModal 
        visible={showItemDetailForm} 
        onClose={closeItemDetailForm}
        modalName={"View Item"}
        data={selectedItemDetail}
        // salesOrderDetails={salesOrderDetails} setSalesOrderDetails={setSalesOrderDetails}
        isEditable={false}
      />
    </>
  );
};
//#endregion













//#region Filter
const FilterModal = ({
  visible, onClose, modalName,
  statusFilter, setStatusFilter,
}) => {
  const [failMessage, setFailMessage] = useState("");
  const [_statusFilter, _setStatusFilter] = useState(statusFilter);

  useEffect(() => {
    if(visible){
      _setStatusFilter(statusFilter)
    }
  }, [visible, statusFilter])

  const handleSubmit = async () => {
    setStatusFilter(_statusFilter);
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

  if (!visible) return null;

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-lg p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">
                    Status
                  </label>
                  <InvoiceStatusSelectWithAll data={_statusFilter} setData={_setStatusFilter} isEditable={true}/>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Alert */}
      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
//#endregion